import { RootState } from "@/store/store";
import { explainWithAiWidgetDataSelector } from "@/store/explain-with-ai/selectors/slice-data/explainWithAiWidgetDataSelector";

export const explainWithAiWidgetIdSelector = (
  state: RootState,
): string | undefined => explainWithAiWidgetDataSelector(state)?.id;
